<p>filter-client-payment-term works!</p>
